export default "https://d3fbpisbzpk8wt.cloudfront.net/20267211251/receiptScanNgBackgroundSimilar-bundle-6100469f8f5bcbd783b52b9e08e0c7d2.png";